module.exports = __webpack_public_path__ + "img/mt_clickbait_style_camera.05654daf.svg";